import React from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";

const Root = () => {
  return (
    <Box sx={{ backgroundColor: "#000" }}>
      <Navbar />
      <Outlet />
    </Box>
  );
};

export default Root;
